<script setup>
// Abratel: modal com iframe do painel (/_panel). Substitui o modal do
// inject.js (ensureModal/openModal) — agora compilado no fork.
import { onMounted, onBeforeUnmount } from 'vue';

defineProps({
  title: { type: String, required: true },
  url: { type: String, required: true },
});

const emit = defineEmits(['close']);

const onKeydown = e => {
  if (e.key === 'Escape') emit('close');
};
// ticket.html avisa via postMessage quando o ticket é criado/fechado.
const onMessage = e => {
  if (e.data?.type === 'ticket-close') emit('close');
};

onMounted(() => {
  document.addEventListener('keydown', onKeydown);
  window.addEventListener('message', onMessage);
});
onBeforeUnmount(() => {
  document.removeEventListener('keydown', onKeydown);
  window.removeEventListener('message', onMessage);
});
</script>

<template>
  <teleport to="body">
    <div
      class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/55 p-5"
      @click.self="emit('close')"
    >
      <div
        class="bg-white dark:bg-n-solid-2 rounded-2xl w-full max-w-[min(1000px,96vw)] h-[88vh] flex flex-col shadow-2xl overflow-hidden"
      >
        <div
          class="flex items-center px-4 py-3 border-b border-n-weak flex-shrink-0"
        >
          <span class="font-semibold text-[15px] flex-1 text-n-slate-12">
            {{ title }}
          </span>
          <button
            type="button"
            class="text-2xl leading-none text-n-slate-10 hover:text-n-slate-12 px-1"
            @click="emit('close')"
          >
            ×
          </button>
        </div>
        <iframe
          :src="url"
          class="flex-1 w-full border-0"
          allow="clipboard-write"
        />
      </div>
    </div>
  </teleport>
</template>
